export const CATEGORIES = ["Écharpes/étoles", "Bonnets/capuches", "Pulls", "Crop tops", "Ponchos/vestes", "Châles/Chèches", "Accessoires"];
